export default __webpack_public_path__ + "static/media/round-arow.21402e91.svg";